import React from "react";
import { Route, Routes } from "react-router-dom";

import PaymentAllList from "../views/page/payment/AllList";
import PaymentCompleteList from "../views/page/payment/CompleteList";
import PaymentView from "../views/page/payment/PaymentView";
import PaymentCancelList from "../views/page/payment/CancelList";

function RouterPayment() {
  return (
    <>
      <Routes>
        <Route exact path="/History/All" element={<PaymentAllList />} />
        <Route exact path="/History/Complete" element={<PaymentCompleteList />} />
        <Route exact path="/History/Cancel" element={<PaymentCancelList />} />
        <Route exact path="/History/View/:pay_seq" element={<PaymentView />} />
      </Routes>
    </>
  );
}

export default RouterPayment;